module.exports = __webpack_public_path__ + "static/img/res_2.5ec169d5.png";